import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.sass']
})
export class ConfirmModalComponent implements OnInit {

  public message: string = '';

  constructor(private modalService: BsModalService, private modalRef: BsModalRef) { }

  ngOnInit(): void {
  }

  confirm(): void {
    if (this.modalRef.content.callback != null) {
      this.modalRef.content.callback('yes');
    }
    this.modalRef.hide();
  }

  decline(): void {
    if (this.modalRef.content.callback != null) {
      this.modalRef.content.callback('no');
    }
    this.modalRef.hide();
  }
}
